import * as React from 'react'
import { YouTubeEmbed as NextYouTubeEmbed } from '@next/third-parties/google'

interface YouTubeEmbedProps {
  videoId: string
  className?: string
}

export const YouTubeEmbed: React.FC<YouTubeEmbedProps> = ({ videoId, className }) => {
  const [isClient, setIsClient] = React.useState(false)

  React.useEffect(() => {
    setIsClient(true)

    // Hide all YouTube branding and icons
    const styleId = 'youtube-no-branding-styles'
    if (!document.getElementById(styleId)) {
      const style = document.createElement('style')
      style.id = styleId
      style.textContent = `
        /* Hide YouTube Play Button */
        .ytp-large-play-button {
          display: none !important;
        }
        
        /* Hide YouTube Logo/Watermark */
        .ytp-watermark {
          display: none !important;
        }
        
        /* Hide YouTube branding in controls */
        .ytp-youtube-button {
          display: none !important;
        }
        
        /* Hide YouTube title overlay */
        .ytp-title {
          display: none !important;
        }
        
        /* Hide YouTube channel name */
        .ytp-title-channel {
          display: none !important;
        }
        
        /* Hide YouTube context menu */
        .ytp-contextmenu {
          display: none !important;
        }
        
        /* Hide related videos overlay */
        .ytp-endscreen-content {
          display: none !important;
        }
        
        /* Hide YouTube gradient overlay */
        .ytp-gradient-top,
        .ytp-gradient-bottom {
          display: none !important;
        }
        
        /* Hide YouTube chrome controls bar completely */
        .ytp-chrome-controls {
          display: none !important;
        }
        
        /* Hide all YouTube UI chrome */
        .ytp-chrome-top {
          display: none !important;
        }
        
        /* Hide YouTube pause overlay */
        .ytp-pause-overlay {
          display: none !important;
        }
        
        /* Ensure iframe responsiveness */
        .youtube-embed-container iframe {
          border-radius: inherit !important;
          border: none !important;
          outline: none !important;
          box-shadow: none !important;
          /* Zoom video more aggressively to remove black bars */
          transform: scale(1.05) !important;
          width: 100% !important;
          height: 110% !important;
          left: -2% !important;
          top: -2% !important;
          object-fit: cover !important;
        }
        
        /* Also apply zoom to the video element inside iframe */
        .youtube-embed-container iframe video {
          object-fit: cover !important;
          width: 100% !important;
          height: 105% !important;
          transform: scale(1.05) !important;
        }
        
        /* Remove any YouTube player borders/outlines */
        .youtube-embed-container iframe,
        .youtube-embed-container iframe *,
        .ytp-player,
        .ytp-chrome-top,
        .ytp-chrome-bottom {
          border: none !important;
          outline: none !important;
          box-shadow: none !important;
        }
        
        /* Remove YouTube player cursor pointer when no controls */
        .youtube-embed-container iframe {
          pointer-events: auto !important;
        }
      `
      document.head.appendChild(style)
    }
  }, [])

  return (
    <div
      className={`youtube-embed-container w-full aspect-video relative overflow-hidden ${className || ''}`}
      style={{
        borderRadius: 'inherit',
        minHeight: '200px',
      }}
    >
      {isClient ? (
        <NextYouTubeEmbed
          videoid={videoId}
          params="controls=0&showinfo=0&rel=0&modestbranding=1&autoplay=1&fs=0&cc_load_policy=0&iv_load_policy=3&disablekb=1&playsinline=1"
          style="position: absolute; top: -10%; left: -10%; width: 120%; height: 120%; border: 0; outline: none; box-shadow: none; border-radius: inherit; transform: scale(1.15);"
        />
      ) : (
        // Server-side placeholder to prevent hydration mismatch
        <div
          className="absolute inset-0 bg-gray-900 flex items-center justify-center"
          style={{ borderRadius: 'inherit' }}
        >
          <div className="text-white text-4xl opacity-70">▶</div>
        </div>
      )}
    </div>
  )
}

export default YouTubeEmbed
